// Allgemeine App-Konstanten
export const APP_NAME = "splusd-solutions";

// Navigationspfade
export const ROUTES = {
  HOME: "/",
  ERP: "/erp",
  SHOPWARE: "/shopware",
  BUSINESS_APPS: "/business-apps",
  MOBILE_APPS: "/mobile-apps",
  INTERFACES: "/interfaces",
  PORTALS: "/portals",
  SALESCOCKPIT: "/salescockpit",
  REFERENCES: "/references",
  ABOUT: "/about",
  CTO_SERVICE: "/cto-service",
  DATENSCHUTZ: "/datenschutz",
  IMPRESSUM: "/impressum",
  AGB: "/agb"
};

// Kontaktinformationen
export const CONTACT = {
  EMAIL: "info@example.com",
  PHONE: "+49 123 456789",
  ADDRESS: "Musterstraße 123, 12345 Musterstadt"
};

// Breakpoints für responsive Design
export const BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1024,
  LARGE_DESKTOP: 1280
}; 